/* FORTE · COLLECTION PAGE behaviour
   Filters and sort submit the form as a plain GET (shareable URLs, no state
   held in JS). Search goes to /search scoped to products. Load More fetches
   the next page of this section through the Section Rendering API and
   appends its cards, updating the count and the next link. */
(function () {
  var root = document.querySelector('[data-fplp-grid]');
  if (!root) return;

  var form = root.querySelector('[data-fplp-filters]');

  /* Filter checkboxes: submit on change, after closing the menu. */
  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-fplp-sort]') || e.target.type === 'checkbox') {
      var q = form.querySelector('[data-fplp-q]');
      if (q && !q.value) q.disabled = true; /* keep ?q= out of the URL when empty */
      form.submit();
    }
  });

  /* Search: products search, not the collection filter. */
  function goSearch() {
    var q = form.querySelector('[data-fplp-q]');
    if (!q || !q.value.trim()) return;
    window.location.href = '/search?type=product&q=' + encodeURIComponent(q.value.trim());
  }
  var btn = form.querySelector('[data-fplp-search-go]');
  if (btn) btn.addEventListener('click', goSearch);
  var qIn = form.querySelector('[data-fplp-q]');
  if (qIn) qIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); goSearch(); } });

  /* Mobile filter row: "Filter by" and the search icon each open a panel below it. */
  form.querySelectorAll('[data-fplp-toggle]').forEach(function (t) {
    t.addEventListener('click', function () {
      var open = t.getAttribute('aria-expanded') !== 'true';
      t.setAttribute('aria-expanded', open);
      form.classList.toggle('is-' + t.dataset.fplpToggle + '-open', open);
      if (open && t.dataset.fplpToggle === 'search' && qIn) qIn.focus();
    });
  });

  /* Phones: one column, so the page is shown in batches of CAP cards and the
     first Load More reveals the rest of what is already loaded before fetching. */
  var CAP = 8;
  var phone = window.matchMedia('(max-width: 749px)');
  var cardsBox = root.querySelector('[data-fplp-cards]');
  function setCount(shown) {
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var p = root.querySelector('[data-fplp-count]');
    if (p && p.dataset.template) p.textContent = p.dataset.template.replace('[shown]', shown).replace('[total]', total);
    var bar = root.querySelector('.fplp-more__rule > span');
    if (bar && total) bar.style.width = (shown * 100 / total) + '%';
  }
  function serverShown() { return parseInt(root.getAttribute('data-shown'), 10) || 0; }
  function uncap() {
    if (!cardsBox.classList.contains('is-capped')) return;
    cardsBox.classList.remove('is-capped');
    setCount(serverShown());
    var reveal = root.querySelector('[data-fplp-reveal]');
    if (reveal) reveal.hidden = true;
  }
  function applyCap() {
    var n = cardsBox.children.length;
    if (!phone.matches || n <= CAP) { uncap(); return; }
    cardsBox.classList.add('is-capped');
    setCount(serverShown() - n + CAP);
    var reveal = root.querySelector('[data-fplp-reveal]');
    if (reveal) reveal.hidden = false;
  }
  applyCap();
  if (phone.addEventListener) phone.addEventListener('change', applyCap);
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-fplp-reveal]')) uncap();
  });

  /* Close an open filter menu when clicking elsewhere. */
  document.addEventListener('click', function (e) {
    root.querySelectorAll('[data-fplp-menu][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* Load more. */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-fplp-load]');
    if (!a) return;
    e.preventDefault();
    if (cardsBox.classList.contains('is-capped')) { uncap(); return; }
    a.classList.add('is-busy');
    var url = new URL(a.href, window.location.origin);
    url.searchParams.set('section_id', root.getAttribute('data-section-id'));
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-fplp-grid]');
        if (!next) throw new Error('no section');
        var cards = next.querySelectorAll('[data-fplp-cards] > *');
        var target = root.querySelector('[data-fplp-cards]');
        cards.forEach(function (c) { target.appendChild(c); });
        wireCards(target);
        var more = root.querySelector('[data-fplp-more]');
        var nextMore = next.querySelector('[data-fplp-more]');
        if (more && nextMore) more.replaceWith(nextMore);
        /* keep the browser URL on page 1 so a reload starts clean */
      })
      .catch(function () { window.location.href = a.href; });
  });

  /* The card's own plan toggle and title-link behaviour live in a script
     inside the home section. Cards rendered here need the same wiring. */
  function wireCards(scope) {
    scope.querySelectorAll('[data-fh-href]:not([data-fplp-wired])').forEach(function (el) {
      el.setAttribute('data-fplp-wired', '');
      el.addEventListener('click', function (e) { if (!e.defaultPrevented) window.location.href = el.dataset.fhHref; });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); window.location.href = el.dataset.fhHref; } });
    });
    scope.querySelectorAll('[data-fh-card]:not([data-fplp-wired])').forEach(function (card) {
      card.setAttribute('data-fplp-wired', '');
      var plan = card.querySelector('[data-fh-plan]');
      if (!plan) return;
      var input = card.querySelector('[data-fh-plan-input]');
      var price = card.querySelector('[data-fh-price]');
      var opts = [].slice.call(plan.querySelectorAll('[data-fh-opt]'));
      opts.forEach(function (b) {
        b.addEventListener('click', function () {
          var sub = b.dataset.fhOpt === 'sub';
          opts.forEach(function (o) { var on = o === b; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          if (input) input.disabled = !sub;
          if (price) price.textContent = sub ? plan.dataset.sub : plan.dataset.once;
        });
      });
    });
  }
  wireCards(root);

  /* Quick add. The card is a plain /cart/add form. On the home page the Forte
     drawer owns the submit; on this page the drawer may be dormant (cart split
     test, control group), and then nothing on the page opened a cart after
     the add: the item landed silently. So the add is owned here, capture
     phase, and then whichever cart is live gets opened: the Forte drawer when
     it has claimed the page, else the SlideCart app, else /cart. */
  function quickAdd(f) {

    var btn = f.querySelector('[type=submit]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin', body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (typeof window.FORTE_CART_OPEN === 'function' && document.documentElement.classList.contains('ig-forte-cart')) {
          if (typeof window.FORTE_CART_REFRESH === 'function') window.FORTE_CART_REFRESH();
          window.FORTE_CART_OPEN();
        } else if (typeof window.SLIDECART_OPEN === 'function') {
          if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
          window.SLIDECART_OPEN();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:add'));
          setTimeout(function () { window.location.href = '/cart'; }, 300);
        }
        /* header count */
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-cart-count], .header__cart__status').forEach(function (n) { n.textContent = c.item_count; n.classList.toggle('is-hidden', !c.item_count); });
        });
      })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }

  /* The SlideCart app and the theme both listen for clicks on add-to-cart
     buttons and each ran its own add (two items per click, no cart shown).
     Taking the click in the capture phase, before either of them, leaves one
     add and one cart open. Keyboard submits go through the same path. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fplp-card] .fh-bs__add');
    if (!btn || btn.disabled) return;
    var f = btn.closest('form[action*="/cart/add"]');
    if (!f) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    quickAdd(f);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('[data-fplp-card] form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    quickAdd(f);
  }, true);
})();
